import React from 'react'
import { Link } from 'react-router-dom'
import examresult from'../Assets/Images/exam_result.png'
const HolidayHomework = () => {
  return (
      <>
      <div className="innerslide">
      <ul className="breadcrumb">
       <li><Link to="/"> Home</Link> </li>
       <li> Information</li>
       <li> Holiday Homework  </li>
   </ul>
    </div>
    <div className="innersec">
    <div className="container">
            <div className="row">
            <div className="col-lg-12">
                    <h1> Holiday Homework  </h1>
            </div>
            </div>
            <div className="row"> 
                <div className="examresult">
                <div className="examresultbox">
                    <Link to="#" target="_blank">
                        <div className="examresultboximg">
                            <img src={examresult} className="img-fluid"  alt="Sacred Heart Convent School, Jagraon" />
                        </div>
                        <div className="examresultboxdesc">
                            <h4>  Title </h4>
                        </div>
                    </Link>
                </div>
                <div className="examresultbox">
                    <Link to="#" target="_blank">
                        <div className="examresultboximg">
                            <img src={examresult} className="img-fluid"  alt="Sacred Heart Convent School, Jagraon" />
                        </div>
                        <div className="examresultboxdesc">
                            <h4>  Title </h4>
                        </div>
                    </Link>
                </div>
                <div className="examresultbox">
                    <Link to="#" target="_blank">
                        <div className="examresultboximg">
                            <img src={examresult} className="img-fluid"  alt="Sacred Heart Convent School, Jagraon" />
                        </div>
                        <div className="examresultboxdesc">
                            <h4>  Title </h4>
                        </div>
                    </Link>
                </div>
                <div className="examresultbox">
                    <Link to="#" target="_blank">
                        <div className="examresultboximg">
                            <img src={examresult} className="img-fluid"  alt="Sacred Heart Convent School, Jagraon" />
                        </div>
                        <div className="examresultboxdesc">
                            <h4>  Title </h4>
                        </div>
                    </Link>
                </div>
                <div className="examresultbox">
                    <Link to="#" target="_blank">
                        <div className="examresultboximg">
                            <img src={examresult} className="img-fluid"  alt="Sacred Heart Convent School, Jagraon" />
                        </div>
                        <div className="examresultboxdesc">
                            <h4>  Title </h4>
                        </div>
                    </Link>
                </div>
            </div>
            </div>
    </div>
    </div>
      </>
  )
}

export default HolidayHomework
